module.exports = __webpack_public_path__ + "media/footer/pinterest-2fe6ad49.svg";